"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAssignModal = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const autocomplete_menu_1 = require("../../components/autocomplete.menu/autocomplete.menu");
const input_1 = require("../../components/input/input");
const input_state_1 = require("../../components/input/input.state");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const sort_1 = require("../../sort");
const userDisplayName_1 = require("../../util/userDisplayName");
const user_assign_modal_style_1 = require("./user.assign.modal.style");
const user_card_1 = require("./user.card");
(0, theme_1.addStyles)(user_assign_modal_style_1.Style);
const USER_ID_UNASSIGN = '$user_unassign$';
class UserAssignModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, collections) {
        super(ctx);
        this.assign = true;
        this.collections = collections;
        this.inputState = new input_state_1.InputState(i18n_1.T.ROLE_USER);
        this.addState(this.inputState);
        this.menu = new autocomplete_menu_1.AutoCompleteMenu({
            inputState: this.inputState,
            options: () => this.userOptions,
            optionView: (option, nameParts) => this.viewUserCard(option, nameParts),
            onselect: (option) => this.selectUser(option),
        });
    }
    get loadingUsers() {
        const users = services_1.Services.UserProfile.list;
        return users == null || users.length === 0;
    }
    get userOptions() {
        if (this.loadingUsers) {
            return [];
        }
        const options = [
            {
                id: USER_ID_UNASSIGN,
                value: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UNASSIGNED),
            },
        ];
        const users = services_1.Services.UserProfile.list;
        const sortedUsers = sort_1.IkeSort.byKey(users.slice(), ['firstname', 'lastname', 'username'], sort_1.IkeSort.ASC);
        for (const user of sortedUsers) {
            options.push({
                id: user.objectId,
                value: (0, userDisplayName_1.userDisplayName)(user),
            });
        }
        return options;
    }
    get nodes() {
        if (this.loadingUsers) {
            return (0, mithril_1.m)('div', { className: user_assign_modal_style_1.CSS.container }, spinner_1.Spinner.view());
        }
        return (0, mithril_1.m)('div', { className: user_assign_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: user_assign_modal_style_1.CSS.content }, [
                (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_ASSIGN_CONFIRM, { count: this.collections.length })),
                this.viewInput(),
            ]),
            (0, mithril_1.m)('div', { className: user_assign_modal_style_1.CSS.menu }, this.menu.view()),
        ]);
    }
    viewInput() {
        if (!this.assign) {
            return user_card_1.UserCardUnassigned.viewChip({
                cancel: () => this.selectUser(),
            });
        }
        if (this.userId == null) {
            return input_1.Input.view(this.inputState);
        }
        const user = services_1.Services.UserProfile.get(this.userId);
        return user_card_1.UserCard.viewChip(user, {
            cancel: () => this.selectUser(),
        });
    }
    canClose() {
        return super.canClose() && !this.menu.isOpen();
    }
    viewUserCard(option, nameParts) {
        if (option.id === USER_ID_UNASSIGN) {
            return {
                view: user_card_1.UserCardUnassigned.view(nameParts),
                action: () => this.unassignUser(),
            };
        }
        const user = services_1.Services.UserProfile.get(option.id);
        if (user == null) {
            return null;
        }
        const me = services_1.Services.User.current;
        const cardCtx = {
            me: me != null && user.objectId === me.objectId,
        };
        return {
            view: user_card_1.UserCard.view(user, nameParts, cardCtx),
            action: () => this.selectUser(option),
        };
    }
    validate() {
        if (!this.assign) {
            this.inputState.setError('');
            return;
        }
        if (this.userId == null) {
            this.inputState.setError(i18n_1.T.USER_ASSIGN_REQUIRED);
        }
        else {
            this.inputState.setError('');
        }
    }
    submit() {
        if (this.assign) {
            return services_1.Services.Collection.assign(this.collections, this.userId);
        }
        return services_1.Services.Collection.assign(this.collections, null);
    }
    selectUser(option) {
        if (option != null) {
            this.userId = option.id;
            this.inputState.setValue(option.value);
            this.inputState.setDisabled(true);
        }
        else {
            this.userId = null;
            this.inputState.setValue('');
            this.inputState.setDisabled(false);
        }
        this.assign = true;
    }
    unassignUser() {
        this.selectUser(null);
        this.assign = false;
    }
}
exports.UserAssignModal = UserAssignModal;
tslib_1.__decorate([
    mobx_1.observable
], UserAssignModal.prototype, "userId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], UserAssignModal.prototype, "assign", void 0);
tslib_1.__decorate([
    mobx_1.computed
], UserAssignModal.prototype, "loadingUsers", null);
tslib_1.__decorate([
    mobx_1.computed
], UserAssignModal.prototype, "userOptions", null);
tslib_1.__decorate([
    mobx_1.action
], UserAssignModal.prototype, "selectUser", null);
tslib_1.__decorate([
    mobx_1.action
], UserAssignModal.prototype, "unassignUser", null);
//# sourceMappingURL=user.assign.modal.js.map